import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { IFormRequirement } from "../exports/interfaces";
import { marked } from "marked";

interface FormRequirementsPopupProps {
  open: boolean;
  onClose: () => void;
  formRequirement: IFormRequirement[];
}

const FormRequirementsPopup: React.FC<FormRequirementsPopupProps> = ({
  open,
  onClose,
  formRequirement,
}) => {
  const [openAccordion, setOpenAccordion] = useState<string | null>();

  const toggleAccordion = (key: string) => {
    setOpenAccordion((prev) => (prev === key ? null : key));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          height: "600px",
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pr: 5,
          padding: "8px 24px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <h4 className="section-title__title">Form Requirements Guide</h4>
        </div>
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
          }}
        >
          <i className="icon-cross" style={{ fontSize: "16px" }}></i>
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <div className="row">
          <div className="col-xl-12">
            {formRequirement.map((section) => {
              const key = `step-${section.id}`;
              const isOpen = openAccordion === key;

              return (
                <div className="faq-page__single" key={section.id}>
                  <div
                    className="accrodion-grp faq-one-accrodion"
                    data-grp-name="form-requirements"
                  >
                    <div className={`accrodion ${isOpen ? "active" : ""}`}>
                      <div
                        className="accrodion-title"
                        onClick={() => toggleAccordion(key)}
                      >
                        <h4>
                          <div style={{ width: "90%" }}>{section.name}</div>
                        </h4>
                      </div>
                      <div
                        className="accrodion-content"
                        style={{
                          marginTop: isOpen ? "-6px" : "-11px",
                          display: isOpen ? "block" : "none",
                        }}
                      >
                        <div
                          className="inner"
                          dangerouslySetInnerHTML={{
                            __html: marked(section.description) as string,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default FormRequirementsPopup;
